import React from 'react';
import { atoms } from 'lmc-ui-library';
import { atoms as NewAtoms } from 'lmc-ui-library-rebrand';
import css from './Logo.module.scss';

const Logo: React.FC<{ newUi: boolean }> = ({ newUi = false }) => {
  if (newUi) return <NewAtoms.Logo className={css.logo} variant={'light'} />;
  return <atoms.Logo className={css.logo} variant={'light'} />;
};

export default Logo;
